import { IonIcon } from "@ionic/react";
import { arrowDownCircleOutline, arrowUpCircleOutline, caretUpCircleOutline, listCircleOutline } from "ionicons/icons";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import Api from "../utils/api";


const CustomBox = ({ id, title, count, total }) => {

    return (
        <Col sm={6} md={3} lg={3}>
            <Row id={'box-status-' + id} className="status-box">
                <Col md={8}>
                    <div><b>{title}</b></div>
                    <div className="stream-percent">{calculePercent(count, total)}%</div>
                </Col>
                <Col md={4} className="text-end">
                    <span className="stream-count">{count}</span>
                </Col>
            </Row>
        </Col>

    )

}


const CustomBox3 = ({ id, title, count, total, icon }) => {

    return (
        <Col xs={6} md={3} lg={3} className="mt-3">
            <Row id={'box-status-' + id} className="status-box">
                <Col xs={8}>
                    <div><b>{title}</b></div>
                    <span className="mt-1 fs-2">{count}</span>
                </Col>
                <Col xs={4} className="text-end d-none d-md-block">
                    <div className="stream-percent">{calculePercent(count, total)}%</div>
                    <div className="mt-1"><IonIcon icon={icon} /></div>
                </Col>
            </Row>
        </Col>

    )

}



const CustomBox2 = ({ id, title, count, total, icon, color }) => {

    return (
        <Col sm={6} md={3} lg={3}>
            <Row className="status-box2">
                <Col md={8}>
                    <div><b>{title}</b></div>
                    <span className="mt-1 fs-3">{count}</span>
                </Col>
                <Col md={4} className="text-end">
                    <div className="stream-percent">{calculePercent(count, total)}%</div>
                    <div className="mt-1"><IonIcon icon={icon} size="large" color={color} /></div>
                </Col>
            </Row>
        </Col>

    )

}


const calculePercent = (value, total) => {
    const porcentaje = (value / total) * 100;
    return porcentaje.toFixed(1); // Redondear a dos decimales
}


const TopBar = () => {

    const [total, setTotal] = useState(0);

    const [stats, setStats] = useState({
        online: 0,
        offline: 0,
        backup: 0,
        failed: 0
    });


    useEffect(() => {
        fetchData()
    }, []);

    useEffect(() => {
        const t = stats.online + stats.failed + stats.offline + stats.backup
        setTotal(t)
    }, [stats]);



    const fetchData = async () => {
        try {
            const data = await Api.get('/fullstats');
            setStats(data);
        } catch (error) {
            console.error('Error al obtener los datos:', error);
        }
    };


    return (
        <>
            {
                /*
                <Row className="justify-content-end gx-5">
                    <CustomBox id='all' title="Streams" count={total} total={total} />
                    <CustomBox id={'up'} title="Online" count={stats.online} total={total} />
                    <CustomBox id={'down'} title="Fallidos" count={stats.failed} total={total} />
                    <CustomBox id={'backup'} title="Backup" count={stats.backup} total={total} />
                </Row>

                */
            }

            {
                /*
                <Row className="justify-content-end gx-5 mt-3">
                    <CustomBox2 id='all' title="Streams" count={total} total={total} icon={listCircleOutline} color="primary" />
                    <CustomBox2 id={'up'} title="Online" count={stats.online} total={total} icon={arrowUpCircleOutline} color="success" />
                    <CustomBox2 id={'down'} title="Fallidos" count={stats.failed} total={total} icon={arrowDownCircleOutline} color="danger" />
                    <CustomBox2 id={'backup'} title="Backup" count={stats.backup} total={total} icon={caretUpCircleOutline} color="warning" />
                </Row>
                */
            }

            {/*
            <Row className="justify-content-end gx-5 mt-3">
                <CustomBox2 id='all' title="Streams" count={total} total={total} icon={listCircle} color="primary" />
                <CustomBox2 id={'up'} title="Online" count={stats.online} total={total} icon={arrowUpCircle} color="success" />
                <CustomBox2 id={'down'} title="Fallidos" count={stats.failed} total={total} icon={arrowDownCircle} color="danger" />
                <CustomBox2 id={'backup'} title="Backup" count={stats.backup} total={total} icon={caretUpCircle} color="warning" />
            </Row>

        */}
            <Row className="justify-content-end gx-5 mt-3 top-bar">
                <CustomBox3 id='all' title="Streams" count={total} total={total} icon={listCircleOutline} color="primary" />
                <CustomBox3 id='up' title="Online" count={stats.online} total={total} icon={arrowUpCircleOutline} color="success" />
                <CustomBox3 id='down' title="Fallidos" count={stats.failed} total={total} icon={arrowDownCircleOutline} color="danger" />
                <CustomBox3 id='backup' title="Backup" count={stats.backup} total={total} icon={caretUpCircleOutline} color="warning" />
            </Row>
        </>

    );
}

export default TopBar;